<template>
  <b-card
    v-if="company && mentorRequest && mentee"
    class="application-card border-0 h-100"
    body-class="px-1"
  >
    <b-row>
      <b-col cols="3" class="d-flex justify-content-center align-items-center">
        <avatar :user="mentee" :size="44"/>
      </b-col>
      <b-col cols="9">
        <div class="mt-0">
          <b>{{ mentee.fullName }}</b>
        </div>
        <div class="mt-0" v-if="jobTitle">
          <p class="m-0 p-0 text-muted">{{ jobTitle }}</p>
        </div>
      </b-col>
    </b-row>

    <!-- job button in tiny mode -->
    <div v-if="mentorRequest.status" class="mt-3">
      <div
        v-if="requestStatus(mentorRequest.status)"
        class="float-left py-2 px-3"
        :style="{
          fontSize: '0.8rem',
          border: '1px solid #fff',
          borderRadius: '3px',
          color: requestStatus(mentorRequest.status).color,
          borderColor: requestStatus(mentorRequest.status).color,
          cursor: 'pointer'
        }"
        v-b-modal="`mentor-request-${mentorRequest.id}`"
      >
        <b>{{ requestStatus(mentorRequest.status).name }}</b>
      </div>
      <div class="py-2 ml-2 float-left">
        <b-link @click="$emit('selectContact', mentee)">Contact</b-link>
      </div>
      <b-link
        class="float-right py-2"
        variant="outline-primary"
        v-b-modal="`mentor-request-${mentorRequest.id}`"
      >
        View Details
      </b-link>
    </div>

    <!-- Mentor Request Details Modal -->
    <b-modal
      v-if="mentorRequest && mentorRequest.status"
      :id="`mentor-request-${mentorRequest.id}`"
      title="Mentor Request"
      body-class="gray-bg"
      size="lg"
      hide-footer
      lazy
    >
      <mentor-request-details
        :mentor="mentee"
        :jobTitle="jobTitle"
        :skillBG="tagBG"
        :status="requestStatus(mentorRequest.status).name"
        :mentorRequest="mentorRequest"
        :actionButtons="mentorRequest.status === 'REQUESTED'"
        @acceptRequest="acceptRequest"
        @rejectRequest="rejectRequest"
      />
    </b-modal>

  </b-card>

</template>

<script>
import tinycolor from 'tinycolor2';
import Avatar from '@/components/users/Avatar';
import MentorRequestDetails from '@/components/mentors/MentorRequestDetails.vue';

const mentorRequestStatuses = {
  'REQUESTED': {
    name: 'PENDING',
    color: '#6c757d',
  },
  'ACTIVE': {
    name: 'ACTIVE',
    color: '#28a745',
  },
  'INACTIVE': {
    name: 'INACTIVE',
    color: '',
  },
  'REJECTED': {
    name: 'DECLINED',
    color: '#bdc3c7',
  },
};

export default {
  components: {
    Avatar,
    MentorRequestDetails,
  },
  props: {
    company: {
      type: Object,
      default: () => null
    },
    mentorRequest: {
      type: Object,
      default: () => null
    },
  },
  computed: {
    mentee() {
      return this.mentorRequest.user;
    },
    jobTitle() {
      return this.getMenteeFieldValue('JOB_TITLES', 'skills');
    },
    tagBG() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
  },
  methods: {
    getMenteeFieldValue(type, group) {
      const { company: { customFields }, mentee: { customFields: menteeCustomFields } } = this;
      if (Array.isArray(customFields) && customFields.length && Array.isArray(menteeCustomFields)) {
        const field = customFields.find(el => el.type === type && el.group === group);
        const fieldKey = field ? field.key : null;
        const menteeField = fieldKey ? menteeCustomFields.find(({ key }) => key === fieldKey) : null;
        return menteeField ? menteeField.value : null;
      }
      return null;
    },
    parseIfPossible(value) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        // not a json
      }
      return value;
    },
    requestStatus(requestStatus) {
      return mentorRequestStatuses[requestStatus];
    },
    acceptRequest() {
      const { mentorRequest } = this;
      this.$emit('acceptMentorRequest', { mentorRequest });
      this.$bvModal.hide(`mentor-request-${this.mentorRequest.id}`);
    },
    rejectRequest() {
      const { mentorRequest } = this;
      this.$emit('rejectMentorRequest', { mentorRequest });
      this.$bvModal.hide(`mentor-request-${this.mentorRequest.id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/MenteeRequestCard.vue